import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    meta: {
      title: "登录",
    },
    component: () => import("../views/Login.vue"),
  },

  {
    path: "/Product",
    name: "Product",
    meta: {
      title: "确认收货",
    },
    component: () => import("../views/Product.vue"),
  },
  {
    path: "/SampleImg",
    name: "SampleImg",
    meta: {
      title: "样品图",
      keepAlive: true,
    },
    component: () => import("../views/SampleImg.vue"),
  },
  {
    path: "/SampleOpinion",
    name: "SampleOpinion",
    meta: {
      title: "填写看样意见",
    },
    component: () => import("../views/SampleOpinion.vue"),
  },
  {
    path: "/DecisionImg",
    name: "DecisionImg",
    meta: {
      title: "样品图",
      keepAlive: true,
    },
    component: () => import("../views/DecisionImg.vue"),
  },
  {
    path: "/DecisionOpinion",
    name: "DecisionOpinion",
    meta: {
      title: "看样决策意见",
    },
    component: () => import("../views/DecisionOpinion.vue"),
  },
  {
    path: "/SampleSupplier",
    name: "SampleSupplier",
    meta: {
      title: "打样供应商",
    },
    component: () => import("../views/SampleSupplier.vue"),
  },
  {
    path: "/successInfo",
    name: "successInfo",
    meta: {
      title: "提交成功",
    },
    component: () => import("../views/successInfo.vue"),
  },
  {
    path: "/introduce",
    name: "introduce",
    meta: {
      title: "索贝十周年杂志",
    },
    component: () => import("../views/introduce.vue"),
  },
  {
    path: "/choose-stash",
    name: "chooseStash",
    meta: {
      title: "索贝十周年杂志",
    },
    component: () => import("../views/ChooseStash.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
